import withPopupMessage from "Components/withPopupMessage";
import VideoDisplay from "./videoDisplay";
export default withPopupMessage(VideoDisplay);
